const Item = {

    // FIELDS
    "category": "الفئة",
    "sub_category": "الفئة الفرعية",
    "brand": "العلامة التجارية",
    "cost_center": "مركز التكلفة",
    "sold": "يمكن بيعه",
    "purchased": "يمكن شراؤه",
    "returned": "يمكن إعادته",
    "name": "الاسم",
    "description": "الوصف",
    "item_code": "رمز المنتج",
    "item_image": "صورة المنتج",
    "group": "المجموعة",
    "primary_unit": "الوحدة الرئيسية",
    "barcode": "الباركود",
    "status": "الحالة",
    "tax": "الضريبة",
    "secondary_unit": "الوحدة الثانوية",
    "weight": "الوزن",
    "conversion": "التحويل",
    "color": "اللون",
    "segment": "القسم",
    "rack": "الرف",
    "search": "البحث",

    // PAGE HEADER
    "item": "المنتج",

    // SECTION HEADING
    "basic_details": "التفاصيل الأساسية",
    "main_details": "التفاصيل الرئيسية",
    "other_details": "تفاصيل أخرى",
    "item_details": "تفاصيل العنصر",
    "qr_code": "رمز الاستجابة السريعة",

    // ERROR
    "error_category": "اختر الفئة",
    "error_sub_category": "اختر الفئة الفرعية",
    "error_brand": "اختر العلامة التجارية",
    "error_cost_center": "اختر مركز التكلفة",
    "error_checkbox": "يجب تحديد خيار واحد على الأقل",
    "error_sold": "",
    "error_purchased": "",
    "error_returned": "",
    "error_name": "أدخل الاسم",
    "error_description": "أدخل الوصف",
    "error_item_code": "أدخل رمز المنتج",
    "error_item_image": "اختر صورة المنتج",
    "error_group": "اختر المجموعة",
    "error_primary_unit": "اختر الوحدة الرئيسية",
    "error_barcode": "أدخل الباركود",
    "error_status": "اختر الحالة",
    "error_tax": "اختر الضريبة",
    "error_secondary_unit": "اختر الوحدة الثانوية",
    "error_weight": "أدخل الوزن",
    "error_conversion": "أدخل التحويل",
    "error_color": "اختر اللون",
    "error_segment": "اختر القسم",
    "error_rack": "اختر الرف",

    // TABLE HEADER
    "table_image": "صورة",
    "table_sub_category": "الفئة الفرعية",
    "table_item_code": "رمز العنصر",
    "table_name": "الاسم",
    "table_status": "الحالة",
}

export default Item;
